import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { PersonFormInterface } from '@zaoblako/shared/modules/client/dtos/person/person-form.dto';
import type { PersonExternalSearchQueryInterface } from '@zaoblako/shared/modules/client/dtos/person/person.external.search.query.dto';
import type { CompanyFindManyQueryInterface } from '@zaoblako/shared/modules/client/dtos/company/company-find-many-query.dto';
import type { CompanyPageInterface } from '@zaoblako/shared/modules/client/dtos/company/company-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';
import { CompanyStatisticsFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-statistics-find.dto';

@Injectable({
  providedIn: 'root'
})
export class CompanyService extends BaseService {
  protected baseUrl = '/basis/client/company';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findMany(queryParams?: CompanyFindManyQueryInterface): Observable<CompanyPageInterface> {
    return this.http.get<CompanyPageInterface>(`${this.baseUrl}/items`, {
      params: queryParams
        ? this.objectToHttpParams(queryParams)
        : {}
    });
  }

  public externalSearch(queryParams: PersonExternalSearchQueryInterface): Observable<PersonFormInterface[]> {
    return this.http.get<PersonFormInterface[]>('/basis/client/external-search', {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getRelatedObjectsStat(id: number): Observable<CompanyStatisticsFindInterface> {
    return this.http.get<CompanyStatisticsFindInterface>(`${this.baseUrl}/${id}/related-objects-stat`);
  }
}
